import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import rules from '@/app/shared/domain/data/rules';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputCpf',
  props: ['modelValue', 'label'],
  emits: ['update:modelValue'],
  setup(__props, { emit }) {




return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _directive_mask = _resolveDirective("mask")!

  return _withDirectives((_openBlock(), _createBlock(_component_v_text_field, {
    rules: [_unref(rules).required, _unref(rules).cpf],
    label: __props.label,
    "model-value": __props.modelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => emit('update:modelValue', value))
  }, null, 8, ["rules", "label", "model-value"])), [
    [_directive_mask, '###.###.###-##']
  ])
}
}

})